export const SignupAside = {
  bindings: {
    list: '<',
    coupon: '<',
  },

  template: `
    <div class="signup-aside p-3 p-lg-4">
      <div class="pt-lg-4">
        <div ng-if="$ctrl.coupon"
          ng-class="{ 'logo logo-{{ $ctrl.coupon | lowercase }}': $ctrl.coupon }">
          {{ $ctrl.coupon }}
        </div>
        <h5 class="h5 mb-3">
          What's included?
        </h5>
        <ul class="fa-ul mb-4">
          <li class="list-item"
            ng-repeat="item in $ctrl.list track by $index">
            <i class="fa-li fa fa-check theme-color"></i>
            <span ng-bind-html="item"></span>
          </li>
        </ul>
        <ul class="fa-ul icon-ul ml-0">
          <li class="list-item d-flex align-items-top p-0 m-1">
            <i class="fa fa-2x fa-lixx icon-secure theme-color"></i>
            <span class="mt-2 ml-2 text-dark">
              Secure SSL Payment
            </span>
          </li>
          <li class="list-item d-flex align-items-top p-0 m-1">
            <i class="fa fa-2x fa-lixx icon-privacy theme-color"></i>
            <span class="mt-2 ml-2 text-dark">
              We'll always keep your details private
            </span>
          </li>
        </ul>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupAside.js